import { CoveringDTO } from './CoveringDTO';

export class RoomDTO {
  public id?: number;
  public uuid: string;
  public corners: string[];
  public floorCovering: CoveringDTO;
  public ceilingCovering: CoveringDTO;

  constructor(uuid: string, corners: string[], floorCovering: CoveringDTO, ceilingCovering: CoveringDTO, id?: number) {
    this.uuid = uuid;
    this.id = id;
    this.corners = corners;
    this.floorCovering = floorCovering;
    this.ceilingCovering = ceilingCovering;
  }
}
